/**
 * Converts a string to HTML entities.
 *
 * @param text - The text to convert.
 * @returns The converted HTML string.
 */
export const toHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/>/g, "&gt;")
    .replace(/≥/g, "&ge;")
    .replace(/≤/g, "&le;")
    .replace(/</g, "&lt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;")
    .replace(/\n/g, "<br/>")
    .replace(/\u00a0/g, "&nbsp;");

/**
 * Converts a string from HTML entities.
 *
 * @param text - The HTML string to convert.
 * @returns The converted text.
 */
export const fromHtml = (text: string): string =>
  text
    .replace(/&nbsp;/g, "\u00a0")
    .replace(/<br\/>/g, "\n")
    .replace(/&apos;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&le;/g, "≤")
    .replace(/&ge;/g, "≥")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");
